"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

require("../../shared/styles/global.css");

require("./Typography.css");

require("../../shared/styles/spacing.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var presets = {
  header1: {
    componentEl: 'h1',
    color: 'ink',
    size: 'xxl',
    weight: 'reg',
    inline: false,
    uppercase: false,
    margin: {
      top: 'none',
      bottom: 'md'
    }
  },
  header2: {
    componentEl: 'h2',
    color: 'ink',
    size: 'xl',
    weight: 'reg',
    inline: false,
    uppercase: false,
    margin: {
      top: 'none',
      bottom: 'md'
    }
  },
  header3: {
    componentEl: 'h3',
    color: 'ink',
    size: 'lg',
    weight: 'reg',
    inline: false,
    uppercase: false,
    margin: {
      top: 'none',
      bottom: 'sm'
    }
  },
  header4: {
    componentEl: 'h4',
    color: 'ink',
    size: 'md',
    weight: 'bold',
    inline: false,
    uppercase: false,
    margin: {
      top: 'none',
      bottom: 'sm'
    }
  },
  link: {
    componentEl: 'a',
    color: 'blurple',
    size: 'inherit',
    weight: 'med',
    inline: true,
    uppercase: false,
    margin: null
  },
  label1: {
    componentEl: 'span',
    color: 'ink',
    size: 'sm',
    weight: 'med',
    inline: false,
    uppercase: false,
    margin: {
      top: 'none',
      bottom: 'sm'
    }
  },
  label2: {
    componentEl: 'span',
    color: 'asphalt',
    size: 'sm',
    weight: 'bold',
    inline: false,
    uppercase: true,
    margin: {
      top: 'none',
      bottom: 'sm'
    }
  },
  note: {
    componentEl: 'small',
    color: 'asphalt',
    size: 'sm',
    weight: 'reg',
    inline: false,
    uppercase: false,
    margin: null
  },
  bodytext: {
    componentEl: 'p',
    color: 'ink',
    size: 'md',
    weight: 'reg',
    inline: false,
    uppercase: false,
    margin: {
      top: 'none',
      bottom: 'sm'
    }
  }
};

function Typography(_ref) {
  var componentEl = _ref.componentEl,
      align = _ref.align,
      className = _ref.className,
      color = _ref.color,
      inline = _ref.inline,
      margin = _ref.margin,
      weight = _ref.weight,
      size = _ref.size,
      truncate = _ref.truncate,
      uppercase = _ref.uppercase,
      variant = _ref.variant,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "align", "className", "color", "inline", "margin", "weight", "size", "truncate", "uppercase", "variant"]);

  var cssClasses = ['st_text'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);

  if (variant) {
    cssClasses.push("st_text--v-" + variant);
  }

  var componentProps = {}; // Setting defaults here and not defaultProps
  // Updated when we added supprot for variants in order to allow overrides
  // Otherwise we have no way of knowing whether a user meant o override a variant
  // or whether we are getting the prop value from defaultProps

  var defaults = {
    align: 'inherit',
    componentEl: utils.componentEl.defaults,
    color: 'ink',
    inline: false,
    weight: 'reg',
    size: 'md',
    uppercase: false,
    truncate: false
  }; // set base font styles
  // either based on variant defaults
  // or just text defaults

  if (variant && Object.prototype.hasOwnProperty.call(presets, variant)) {
    componentProps = _extends(_extends({}, defaults), presets[variant]);
  } else {
    componentProps = _extends({}, defaults);
  }

  if (componentEl) componentProps.componentEl = componentEl;
  if (margin) componentProps.margin = margin;
  if (color) componentProps.color = color;
  if (typeof inline === 'boolean') componentProps.inline = inline;
  if (weight) componentProps.weight = weight;
  if (size) componentProps.size = size;
  if (typeof uppercase === 'boolean') componentProps.uppercase = uppercase;
  cssClasses = utils.spacing.addSpacingClasses({
    margin: componentProps.margin,
    cssClasses: cssClasses
  });

  if (align) {
    cssClasses.push("st_text--align-" + align);
  }

  if (componentProps.inline) cssClasses.push('st_text--inline');

  if (componentProps.size) {
    cssClasses.push("st_text--" + componentProps.size);
  }

  if (truncate) cssClasses.push('st_text--truncate');
  if (componentProps.color) cssClasses.push("st_text--color-" + componentProps.color);
  if (componentProps.weight) cssClasses.push("st_text--weight-" + componentProps.weight);
  if (componentProps.uppercase) cssClasses.push('st_text--uppercase');
  var Component = componentProps.componentEl;
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps));
}

Typography.propTypes = {
  /**
  dom element or component to use for outermost wrapper.
  Defaults to most appropriate tag for variant, or div if unspecified
  */
  componentEl: utils.componentEl.props,

  /** text alignment */
  align: _propTypes["default"].oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /**
  Color of text.
  Defaults to most appropriate for variant,
  or ink if no variant.
  */
  color: _propTypes["default"].oneOf(['white', 'ink', 'blurple', 'asphalt', 'lava', 'emerald', 'inherit']),

  /**
  Whether text is inline or block.
  Defaults to most appropriate for variant, or false if no variant.
  */
  inline: _propTypes["default"].bool,

  /** margin for box, if any */
  margin: utils.spacing.marginProps,

  /**
  Size of text. Defaults to appropriate for variant, or md if no variant. */
  size: _propTypes["default"].oneOf(['sm', 'md', 'lg', 'xl', 'xxl', 'inherit']),

  /**
  Font weight. Defaults to appropriate weight for variant, or reg if no variant
  */
  weight: _propTypes["default"].oneOf(['reg', 'med', 'bold', 'black']),

  /** whether text should truncate with an ellipsis if longer than one line */
  truncate: _propTypes["default"].bool,

  /**
  Whether text should be all-caps or not.
  Defaults to most appropriate for variant, or false if no variant */
  uppercase: _propTypes["default"].bool,

  /**
    Shortcut for setting multiple properties at once through presets.
  */
  variant: _propTypes["default"].oneOf(['header1', 'header2', 'header3', 'header4', 'bodytext', 'link', 'label1', 'label2', 'note'])
};
Typography.defaultProps = {
  align: 'inherit',
  truncate: false
};
var _default = Typography;
exports["default"] = _default;